























import TheG01Content from "@/general/components/pages/parts/Ranking/TheG01Content.vue";
import G01ItemListGroup from "@/general/components/pages/parts/Ranking/G01ItemListGroup.vue";
import { Component, Vue } from "vue-property-decorator";
import items from "@/general/store/modules/items";
import commons from "@/common/store/modules/commons";
import { rankingByPoints } from "@/general/store/api";

@Component({
  components: {
    TheG01Content,
    G01ItemListGroup
  }
})
export default class TheG01ContentPoint extends Vue {
  rankingPoints: any = [];

  async created() {
    this.rankingPoints = await rankingByPoints();
  }

  get unit() {
    return commons?.OrgPageSpecific?.point_name;
  }
  get categories() {
    return this.rankingPoints.map((item: any, index: number) => {
      if (item.lower_limit == null) {
        item["category_name"] = "~" + item.upper_limit + " " + this.unit;
      } else {
        if (item.upper_limit == null) {
          item["category_name"] = item.lower_limit + " " + this.unit + " ~";
        } else {
          item["category_name"] =
            item.lower_limit + "-" + item.upper_limit + " " + this.unit;
        }
      }

      item["category_id"] = "ex-" + index;
      return item;
    });
  }
}
